import React, { createContext, useState, ReactNode } from 'react';

export type IPageProviderData = {
  currentPageSlug?: string;
  parentPageSlug?: string;
};
// Define the type for the context value
export type IPageProviderContext = {
  currentPageSlug?: string;
  parentPageSlug?: string;
  updateData: (data: IPageProviderData) => void;
}

// Create the context
const PageProviderContext = createContext<IPageProviderContext | null>(null);

// Define the props type for the PageProvider component
interface PageProviderProps {
  children: ReactNode;
  slug?: string;
  parentPageSlug?: string;
}

// Create the provider component
const PageProvider: React.FC<PageProviderProps> = ({ children, slug, parentPageSlug }) => {
  const [data, setData] = useState<IPageProviderData>({currentPageSlug: slug, parentPageSlug});

  // Define the updateData function
  const updateData = (data: IPageProviderData) => {
    setData(data);
  };

  // Create the context value object
  const contextValue: IPageProviderContext = {
    ...data,
    updateData,
  };

  return (
    <PageProviderContext.Provider value={contextValue}>
      {children}
    </PageProviderContext.Provider>
  );
};

export { PageProviderContext, PageProvider };
